import { makeStyles } from "tss-react/mui"
import { CircularProgress, Grid, Stack } from "@mui/material"
import { CreateOrderDialogTitle } from "../components/CreateOrderDialogTitle"
import { CreateOrderDialogFlow } from "../createOrderTypes"

const useStyles = makeStyles()(() => ({
    content: {
        minHeight: "20rem",
    },
}))
type CreateOrderDialogLoadingProps = Readonly<{
    handleClose: () => void
    flowConfig?: CreateOrderDialogFlow
}>

export function CreateOrderDialogLoading({ handleClose, flowConfig }: CreateOrderDialogLoadingProps) {
    const { classes } = useStyles()

    return (
        <Stack>
            <CreateOrderDialogTitle handleClose={handleClose} flowConfig={flowConfig} />
            <Stack>
                <Grid container alignItems="center" justifyContent="center" className={classes.content}>
                    <CircularProgress size={70} />
                </Grid>
            </Stack>
        </Stack>
    )
}
